export function getDatumKey(item) {
    return item.groupName !== undefined
        ? item.name + " - " + item.groupName
        : item.name;
}
//# sourceMappingURL=getDatumKey.js.map